import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, Component, Inject, ViewEncapsulation, Injectable, NgModule } from '@angular/core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@azavista/components/shared';
import { CriteriaRelationOperator, clone, FIELD_OPERATOR_WITH_MULTIPLE_VALUE, pick, omit } from '@azavista/components/shared';
import * as i2 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i5 from '@azavista/components/input-field';
import { AzavistaInputFieldModule } from '@azavista/components/input-field';
import * as i2$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i4 from '@azavista/components/button';
import { AzavistaButtonModule } from '@azavista/components/button';
import * as i6 from '@angular/material/icon';
import * as i7 from '@angular/material/button';
import { firstValueFrom } from 'rxjs';
const _c0 = () => ({});
function AzavistaFilterCriteriaTreeNodeComponent_azavista_input_field_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 5);
    i0.ɵɵlistener("valueChanged", function AzavistaFilterCriteriaTreeNodeComponent_azavista_input_field_1_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectCategoryFieldValue($event.value));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r1.categoryFieldValue)("field", ctx_r1.categoryField)("editMode", true)("readonlyMode", ctx_r1.readonly)("layoutDensity", "slim");
  }
}
function AzavistaFilterCriteriaTreeNodeComponent_azavista_input_field_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 6);
    i0.ɵɵlistener("autocompleteSearchTextChanged", function AzavistaFilterCriteriaTreeNodeComponent_azavista_input_field_2_Template_azavista_input_field_autocompleteSearchTextChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFieldSelectorTextChanges($event));
    })("valueChanged", function AzavistaFilterCriteriaTreeNodeComponent_azavista_input_field_2_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFieldSelectorValueChanges($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r1.fieldSelectorValue)("options", ctx_r1.fieldSelectorOptions)("field", ctx_r1.fieldSelectorField)("editMode", true)("readonlyMode", ctx_r1.readonly)("layoutDensity", "slim");
  }
}
function AzavistaFilterCriteriaTreeNodeComponent_azavista_input_field_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 7);
    i0.ɵɵlistener("valueChanged", function AzavistaFilterCriteriaTreeNodeComponent_azavista_input_field_3_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onOperatorChanges($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r1.criteriaItem.operator)("editMode", true)("readonlyMode", ctx_r1.readonly)("field", ctx_r1.operatorField);
  }
}
function AzavistaFilterCriteriaTreeNodeComponent_azavista_input_field_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 8);
    i0.ɵɵlistener("valueChanged", function AzavistaFilterCriteriaTreeNodeComponent_azavista_input_field_4_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onValueChanges($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("hidden", !ctx_r1.operatorHasValue(ctx_r1.criteriaItem.operator));
    i0.ɵɵproperty("editMode", true)("readonlyMode", ctx_r1.readonly)("value", ctx_r1.criteriaItem.value)("textAreaOptions", i0.ɵɵpureFunction0(7, _c0))("field", ctx_r1.valueField);
  }
}
function AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_template_1_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_template_1_button_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const i_r2 = i0.ɵɵnextContext(2).index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onDeleteNode(i_r2));
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "close");
    i0.ɵɵelementEnd()();
  }
}
function AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_template_1_button_0_Template, 3, 0, "button", 5);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.filterData.readonly);
  }
}
function AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_container_3_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementContainer(1, 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r2 = i0.ɵɵnextContext(2).index;
    i0.ɵɵnextContext();
    const operatorEl_r4 = i0.ɵɵreference(3);
    i0.ɵɵstyleProp("visibility", i_r2 === 0 ? "hidden" : "visible");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", operatorEl_r4);
  }
}
function AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_container_3_azavista_filter_criteria_tree_node_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-filter-criteria-tree-node", 13);
    i0.ɵɵlistener("deleteNode", function AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_container_3_azavista_filter_criteria_tree_node_3_Template_azavista_filter_criteria_tree_node_deleteNode_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const i_r2 = i0.ɵɵnextContext(2).index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onDeleteNode(i_r2));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const criteria_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("allFields", ctx_r2.filterData.availableFields)("criteriaItem", criteria_r6)("readonly", ctx_r2.filterData.readonly);
  }
}
function AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_container_3_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_container_3_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const i_r2 = i0.ɵɵnextContext(2).index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onDeleteNode(i_r2));
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "close");
    i0.ɵɵelementEnd()();
  }
}
function AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵtemplate(2, AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_container_3_div_2_Template, 2, 3, "div", 8)(3, AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_container_3_azavista_filter_criteria_tree_node_3_Template, 1, 3, "azavista-filter-criteria-tree-node", 9);
    i0.ɵɵelement(4, "div", 10);
    i0.ɵɵtemplate(5, AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_container_3_button_5_Template, 3, 0, "button", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const criteria_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("filter-tree__tree-nodes__indent", ctx_r2.currentTreeLevel > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r2.criteriaTree == null ? null : ctx_r2.criteriaTree.criteria.length) > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(criteria_r6.operator === "or" || criteria_r6.operator === "and"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.filterData.readonly);
  }
}
function AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_container_4_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_container_4_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const i_r2 = i0.ɵɵnextContext(2).index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onDeleteNode(i_r2));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "REMOVE"), " ");
  }
}
function AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 14)(2, "div", 15);
    i0.ɵɵelementContainer(3, 12);
    i0.ɵɵtemplate(4, AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_container_4_button_4_Template, 3, 3, "button", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "azavista-filter-criteria-tree-nodes", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    const criteria_r6 = ctx_r8.$implicit;
    const i_r2 = ctx_r8.index;
    const ctx_r2 = i0.ɵɵnextContext();
    const operatorEl_r4 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("filter-tree__tree-nodes__indent", ctx_r2.currentTreeLevel > 0);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("display", i_r2 === 0 ? "none" : "flex");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", operatorEl_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.filterData.readonly);
    i0.ɵɵadvance();
    i0.ɵɵproperty("criteriaTree", criteria_r6)("currentTreeLevel", ctx_r2.currentTreeLevel + 1)("filterData", ctx_r2.filterData);
  }
}
function AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_template_1_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(3, AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_container_3_Template, 6, 5, "ng-container", 4)(4, AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_ng_container_4_Template, 6, 9, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const criteria_r6 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !(criteria_r6.operator === "or" || criteria_r6.operator === "and"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", criteria_r6.operator === "or" || criteria_r6.operator === "and");
  }
}
function AzavistaFilterCriteriaTreeNodesComponent_div_1_azavista_flat_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-flat-button", 21);
    i0.ɵɵlistener("click", function AzavistaFilterCriteriaTreeNodesComponent_div_1_azavista_flat_button_1_Template_azavista_flat_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.addCriteria());
    });
    i0.ɵɵtext(1, " + ");
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, "ADD"));
  }
}
function AzavistaFilterCriteriaTreeNodesComponent_div_1_azavista_flat_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-flat-button", 21);
    i0.ɵɵlistener("click", function AzavistaFilterCriteriaTreeNodesComponent_div_1_azavista_flat_button_2_Template_azavista_flat_button_click_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.addCriteriaRelation());
    });
    i0.ɵɵtext(1, " + \xA0 ");
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "uppercase");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 3, i0.ɵɵpipeBind1(4, 1, ctx_r2.relationTranslations[ctx_r2.criteriaTree == null ? null : ctx_r2.criteriaTree.operator])), "");
  }
}
function AzavistaFilterCriteriaTreeNodesComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, AzavistaFilterCriteriaTreeNodesComponent_div_1_azavista_flat_button_1_Template, 5, 3, "azavista-flat-button", 20)(2, AzavistaFilterCriteriaTreeNodesComponent_div_1_azavista_flat_button_2_Template, 6, 5, "azavista-flat-button", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    let tmp_4_0;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("filter-tree__tree-nodes__indent", ctx_r2.currentTreeLevel > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r2.filterData == null ? null : ctx_r2.filterData.filter == null ? null : ctx_r2.filterData.filter.nodeOnlyOnLastLevel) || ctx_r2.currentTreeLevel + 1 === ((tmp_3_0 = ctx_r2.filterData == null ? null : ctx_r2.filterData.filter == null ? null : ctx_r2.filterData.filter.treeDepth) !== null && tmp_3_0 !== undefined ? tmp_3_0 : 0));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.currentTreeLevel + 1 < ((tmp_4_0 = ctx_r2.filterData == null ? null : ctx_r2.filterData.filter == null ? null : ctx_r2.filterData.filter.treeDepth) !== null && tmp_4_0 !== undefined ? tmp_4_0 : 1));
  }
}
function AzavistaFilterCriteriaTreeNodesComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 22);
    i0.ɵɵlistener("valueChanged", function AzavistaFilterCriteriaTreeNodesComponent_ng_template_2_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onCriteriaRelationChanges($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("field", ctx_r2.criteriaRelationField)("value", ctx_r2.criteriaTree == null ? null : ctx_r2.criteriaTree.operator)("readonlyMode", ctx_r2.filterData.readonly || (ctx_r2.criteriaRelationField == null ? null : ctx_r2.criteriaRelationField.schema.enum.length) === 1)("editMode", true);
  }
}
function AzavistaFilterCriteriaTreeComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.data.dialogTitle);
  }
}
function AzavistaFilterCriteriaTreeComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "MANAGE_FILTER"));
  }
}
function AzavistaFilterCriteriaTreeComponent_azavista_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-button", 11);
    i0.ɵɵlistener("click", function AzavistaFilterCriteriaTreeComponent_azavista_button_8_Template_azavista_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.clearAll());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "uppercase");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, i0.ɵɵpipeBind1(2, 1, "CLEAR_ALL")), " ");
  }
}
function AzavistaFilterCriteriaTreeComponent_azavista_flat_button_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-flat-button", 12);
    i0.ɵɵlistener("click", function AzavistaFilterCriteriaTreeComponent_azavista_flat_button_10_Template_azavista_flat_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.submit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "uppercase");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, i0.ɵɵpipeBind1(2, 1, "CANCEL")), " ");
  }
}
function AzavistaFilterCriteriaTreeComponent_azavista_button_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-button", 13);
    i0.ɵɵlistener("click", function AzavistaFilterCriteriaTreeComponent_azavista_button_11_Template_azavista_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onDelete());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "uppercase");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, i0.ɵɵpipeBind1(2, 1, "DELETE")), " ");
  }
}
function AzavistaFilterCriteriaTreeComponent_azavista_button_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-button", 14);
    i0.ɵɵlistener("click", function AzavistaFilterCriteriaTreeComponent_azavista_button_12_Template_azavista_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.submit(ctx_r0.data == null ? null : ctx_r0.data.filter));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "uppercase");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r0.isValidFilterTree(ctx_r0.data.filter) || (ctx_r0.data.isSaveButtonEnabledFn == null ? null : ctx_r0.data.isSaveButtonEnabledFn(ctx_r0.data.filter)) === false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, i0.ɵɵpipeBind1(2, 2, "SAVE")), " ");
  }
}
const inputFieldTypeDefaultValue = {
  boolean: false,
  select: [],
  'multi-select': [],
  'from-multi-select': [],
  text: '',
  'virtual-textarea': '',
  url: ''
};
const CRITERIA_RELATIONS_TRANSLATION = {
  [CriteriaRelationOperator.and]: 'AND',
  [CriteriaRelationOperator.or]: 'OR'
};
const CRITERIA_RELATIONS_ARRAY = Object.keys(CRITERIA_RELATIONS_TRANSLATION);
const getCriteriaRelationAttributeTranslations = (sharedSvc, currentLanguage) => {
  return CRITERIA_RELATIONS_ARRAY.map(value => ({
    value,
    trans: {
      [currentLanguage]: sharedSvc.translate(CRITERIA_RELATIONS_TRANSLATION[value]).toUpperCase()
    }
  }));
};
const getNewCriteria = (availableFields, sharedSvc) => {
  const selectedField = availableFields[0];
  return {
    operator: sharedSvc.getAllOperatorsByField(selectedField)[0].name,
    field: selectedField,
    value: getCriteriaDefaultValue(selectedField, sharedSvc)
  };
};
const getAllowedRelations = (treeLevel, allowedCriteriaRelationPerTreeLevel) => {
  const relationBasedOnLevel = allowedCriteriaRelationPerTreeLevel?.[treeLevel];
  return relationBasedOnLevel?.length > 0 ? relationBasedOnLevel : CRITERIA_RELATIONS_ARRAY;
};
const getNewCriteriaTree = (currentTreeLevel, filterData, sharedSvc) => {
  return {
    operator: getAllowedRelations(currentTreeLevel, filterData?.allowedCriteriaRelationPerTreeLevel)[0],
    criteria: [currentTreeLevel + 1 === filterData.filter.treeDepth ? getNewCriteria(filterData?.availableFields, sharedSvc) : getNewCriteriaTree(currentTreeLevel + 1, filterData, sharedSvc)]
  };
};
const isValidFilterTree = filterTree => {
  const {
    name,
    criteriaTree
  } = filterTree ?? {};
  return name && IsValidCriteriaTree(criteriaTree);
};
const IsValidCriteriaTree = criteriaTree => {
  const {
    criteria,
    operator
  } = criteriaTree;
  return operator && (criteria ?? []).every(item => {
    switch (item.operator) {
      case CriteriaRelationOperator.and:
      case CriteriaRelationOperator.or:
        return IsValidCriteriaTree(item);
      default:
        return IsValidCriteriaNode(item);
    }
  });
};
const IsValidCriteriaNode = filterNode => {
  const {
    field,
    operator
  } = filterNode ?? {};
  const isValidOperator = !!field && !!operator;
  return isValidOperator;
};
const formatCriteriaTree = criteriaTree => {
  const clonedCriteriaTree = clone(criteriaTree);
  const {
    criteria
  } = clonedCriteriaTree;
  clonedCriteriaTree.criteria = (criteria ?? []).map(item => {
    switch (item.operator) {
      case CriteriaRelationOperator.and:
      case CriteriaRelationOperator.or:
        return formatCriteriaTree(item);
      default:
        return {
          ...item,
          value: FIELD_OPERATOR_WITH_MULTIPLE_VALUE.includes(item.operator) ? item.value ?? [] : item.value
        };
    }
  });
  return clonedCriteriaTree;
};
const formatFilterTree = filterTree => {
  return {
    ...filterTree,
    criteriaTree: formatCriteriaTree(filterTree.criteriaTree)
  };
};
const clearCriteriaTree = criteriaTree => {
  criteriaTree.criteria.splice(0);
};
const getCriteriaDefaultValue = (field, sharedSvc) => {
  const selectedFieldType = sharedSvc.getFieldTypeFromField(field);
  return getCriteriaDefaultValueByFieldType(selectedFieldType);
};
const getCriteriaDefaultValueByFieldType = selectedFieldType => {
  return inputFieldTypeDefaultValue[selectedFieldType] ?? null;
};
const flatSearchElementToFilterTree = flatSearchElement => {
  return flatSearchElement;
};
const flatSearchParamsToFilterTree = (flatSearchParams, filterId) => {
  return {
    id: filterId,
    name: filterId,
    nodeOnlyOnLastLevel: true,
    treeDepth: 2,
    criteriaTree: {
      operator: CriteriaRelationOperator.or,
      criteria: flatSearchParams.map(tree => ({
        operator: CriteriaRelationOperator.and,
        criteria: tree.map(treeItem => flatSearchElementToFilterTree(treeItem))
      }))
    }
  };
};
const filterTreeToFlatSearchParamsElement = filterNode => {
  return filterNode;
};
const filterTreeToFlatSearchParams = filter => {
  const {
    criteriaTree
  } = filter;
  const convertedCriteria = (criteriaTree?.criteria ?? []).map(tree => tree.criteria.map(criteriaItem => filterTreeToFlatSearchParamsElement(criteriaItem)));
  return convertedCriteria;
};
let AzavistaFilterCriteriaTreeNodeComponent = /*#__PURE__*/(() => {
  class AzavistaFilterCriteriaTreeNodeComponent {
    constructor(sharedSvc, translateService, cdr) {
      this.sharedSvc = sharedSvc;
      this.translateService = translateService;
      this.cdr = cdr;
      this.readonly = false;
      this.deleteNode = new EventEmitter();
      // Autocomplete field for selecting the field
      this.fieldSelectorField = {
        schema: {
          type: 'object'
        },
        component: "object_enum" /* FieldComponentType.objectEnum */,
        editable: true,
        mandatory_for_planners: true
      };
      this.fieldSelectorOptions = {
        restoreLastSelectedValueWhenNoMatch: false,
        enableClearValue: false,
        useInternalFiltering: false
      };
      // select field for selecting the operators
      this.availableOperators = [];
      this.valueCache = {};
      this.getFieldsByCategory = allFields => {
        return allFields.reduce((map, field) => {
          const mapKey = this.getFieldCategoryKey(field);
          map[mapKey] = field;
          return map;
        }, {});
      };
      this.getFieldCategoryKey = field => {
        return field.category == null || field.category == '' ? '' : field.category;
      };
      this.shouldShowFieldCategory = allFieldByCategory => {
        return Object.keys(allFieldByCategory ?? {}).length > 1;
      };
    }
    ngOnInit() {
      this.updateValueCache(this.criteriaItem.field.id, this.criteriaItem);
      this.setCategoryField();
      const selectedField = this.fieldSelectorValue.selected;
      this.selectField(selectedField);
    }
    setCategoryField() {
      this.allFieldByCategory = this.getFieldsByCategory(this.allFields);
      const selectedField = this.allFields.find(({
        id
      }) => id === this.criteriaItem?.field.id);
      const initialCategoryFieldValue = selectedField ? this.getFieldCategoryKey(selectedField) : Object.keys(this.allFieldByCategory ?? {})[0];
      this.selectCategoryFieldValue(initialCategoryFieldValue);
      if (this.shouldShowFieldCategory(this.allFieldByCategory)) {
        this.categoryField = {
          type: 'select',
          editable: true,
          schema: {
            type: 'string',
            enum: Object.keys(this.allFieldByCategory)
          }
        };
      }
    }
    getFieldSelectorValue() {
      const filteredFieldsByCategory = this.allFields?.filter(field => this.getFieldCategoryKey(field) === this.categoryFieldValue) ?? [];
      const selected = this.criteriaItem?.field.id && filteredFieldsByCategory.find(({
        id
      }) => id === this.criteriaItem?.field.id) || filteredFieldsByCategory[0];
      const value = {
        displayProperty: 'label',
        items: filteredFieldsByCategory,
        selected
      };
      return value;
    }
    onFieldSelectorTextChanges(data) {
      if (!this.fieldSelectorOptions.useInternalFiltering) {
        const lowercased = data.text.toLowerCase();
        this.fieldSelectorValue.filteredItems = this.fieldSelectorValue.items.filter(x => x.name.includes(lowercased));
      }
    }
    onFieldSelectorValueChanges(data) {
      this.selectField(data.value);
    }
    selectField(field) {
      this.criteriaItem.field = field ? pick(field, ['id']) : null;
      this.criteriaItem.value = field ? this.valueCache[field.id]?.value ?? getCriteriaDefaultValue(field, this.sharedSvc) : null;
      this.updateOperatorField(field);
      this.updateValueField(field);
    }
    updateValueField(field) {
      this.valueField = null;
      this.cdr.detectChanges();
      if (field) {
        this.valueField = this.formatFieldForValues(field);
        this.cdr.detectChanges();
      }
    }
    updateOperatorField(field) {
      if (!field) {
        this.operatorField = null;
        this.cdr.detectChanges();
        return;
      }
      this.availableOperators = this.sharedSvc.getAllOperatorsByField(field);
      const availableOperatorsName = this.availableOperators.map(({
        name
      }) => name);
      const attributeTranslations = this.availableOperators.map(({
        displayText,
        name
      }) => ({
        value: name,
        trans: {
          [this.translateService.currentLang]: displayText
        }
      }));
      this.criteriaItem.operator = this.criteriaItem.operator && availableOperatorsName.includes(this.criteriaItem.operator) ? this.criteriaItem.operator : this.valueCache[field.id]?.operator ?? availableOperatorsName[0];
      this.operatorField = null;
      this.cdr.detectChanges();
      this.operatorField = {
        id: 'operator',
        schema: {
          type: 'string',
          enum: availableOperatorsName
        },
        builtin: true,
        mandatory_for_planners: true,
        type: 'select',
        label: '',
        category: '',
        name: 'operator',
        attributeTranslations,
        editable: true
      };
      this.cdr.detectChanges();
    }
    onOperatorChanges(changes) {
      this.criteriaItem.operator = changes.value;
      this.updateValueCache(this.criteriaItem?.field?.id, {
        operator: changes.value
      });
    }
    onValueChanges(changes) {
      this.criteriaItem.value = changes.value;
      this.updateValueCache(this.criteriaItem?.field?.id, {
        value: changes.value
      });
    }
    updateValueCache(fieldId, params) {
      this.valueCache[fieldId] = {
        ...this.valueCache[fieldId],
        ...params
      };
    }
    formatFieldForValues(field) {
      const clonedField = this.sharedSvc.clone(field);
      clonedField.editable = true;
      this.sharedSvc.convertFieldEnumToArray(clonedField, "default" /* FieldComponentType.default */);
      return clonedField;
    }
    operatorHasValue(operator) {
      return this.sharedSvc.operatorHasValue(operator);
    }
    selectCategoryFieldValue(category) {
      this.categoryFieldValue = category;
      this.fieldSelectorValue = null;
      this.cdr.detectChanges();
      this.fieldSelectorValue = this.getFieldSelectorValue();
      this.selectField(this.fieldSelectorValue?.selected);
      this.cdr.detectChanges();
    }
    static {
      this.ɵfac = function AzavistaFilterCriteriaTreeNodeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFilterCriteriaTreeNodeComponent)(i0.ɵɵdirectiveInject(i1.AzavistaSharedService), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaFilterCriteriaTreeNodeComponent,
        selectors: [["azavista-filter-criteria-tree-node"]],
        inputs: {
          criteriaItem: "criteriaItem",
          allFields: "allFields",
          readonly: "readonly"
        },
        outputs: {
          deleteNode: "deleteNode"
        },
        standalone: false,
        decls: 5,
        vars: 6,
        consts: [[1, "filter-tree__horizonal-stack"], ["class", "azavista-input-field-filter-category", 3, "value", "field", "editMode", "readonlyMode", "layoutDensity", "valueChanged", 4, "ngIf"], ["class", "azavista-input-field-filter-field", 3, "value", "options", "field", "editMode", "readonlyMode", "layoutDensity", "autocompleteSearchTextChanged", "valueChanged", 4, "ngIf"], ["class", "azavista-input-field-filter-operator", "layoutDensity", "slim", 3, "value", "editMode", "readonlyMode", "field", "valueChanged", 4, "ngIf"], ["class", "azavista-input-field-filter-value", "layoutDensity", "slim", 3, "editMode", "readonlyMode", "value", "textAreaOptions", "field", "hidden", "valueChanged", 4, "ngIf"], [1, "azavista-input-field-filter-category", 3, "valueChanged", "value", "field", "editMode", "readonlyMode", "layoutDensity"], [1, "azavista-input-field-filter-field", 3, "autocompleteSearchTextChanged", "valueChanged", "value", "options", "field", "editMode", "readonlyMode", "layoutDensity"], ["layoutDensity", "slim", 1, "azavista-input-field-filter-operator", 3, "valueChanged", "value", "editMode", "readonlyMode", "field"], ["layoutDensity", "slim", 1, "azavista-input-field-filter-value", 3, "valueChanged", "editMode", "readonlyMode", "value", "textAreaOptions", "field"]],
        template: function AzavistaFilterCriteriaTreeNodeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, AzavistaFilterCriteriaTreeNodeComponent_azavista_input_field_1_Template, 1, 5, "azavista-input-field", 1)(2, AzavistaFilterCriteriaTreeNodeComponent_azavista_input_field_2_Template, 1, 6, "azavista-input-field", 2)(3, AzavistaFilterCriteriaTreeNodeComponent_azavista_input_field_3_Template, 1, 4, "azavista-input-field", 3)(4, AzavistaFilterCriteriaTreeNodeComponent_azavista_input_field_4_Template, 1, 8, "azavista-input-field", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("filter-tree__node--has-category", ctx.categoryField);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.categoryField);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.fieldSelectorValue);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.operatorField);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.valueField);
          }
        },
        dependencies: [i3.NgIf, i5.AzavistaInputFieldComponent],
        encapsulation: 2
      });
    }
  }
  return AzavistaFilterCriteriaTreeNodeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaFilterCriteriaTreeNodesComponent = /*#__PURE__*/(() => {
  class AzavistaFilterCriteriaTreeNodesComponent {
    constructor(sharedSvc, translateService) {
      this.sharedSvc = sharedSvc;
      this.translateService = translateService;
      this.autoGenerateFirstCriteria = false;
      /** Number that represents the node's level/depth in the tree
      *
      ** `0` means the root level
      ** `1` means the children of root
      ** `2` means grand children of root
           @minimum 0
      */
      this.currentTreeLevel = 0;
      this.relationTranslations = CRITERIA_RELATIONS_TRANSLATION;
    }
    ngOnInit() {
      this.criteriaRelationField = this.getCriteriaRelationField();
      if (this.currentTreeLevel === 0 && this.autoGenerateFirstCriteria && this.criteriaTree.criteria.length === 0) {
        if (this.currentTreeLevel + 1 < (this.filterData?.filter?.treeDepth ?? 1)) {
          this.addCriteriaRelation();
        } else {
          this.addCriteria();
        }
      }
    }
    getCriteriaRelationField() {
      const allowedRelations = getAllowedRelations(this.currentTreeLevel, this.filterData?.allowedCriteriaRelationPerTreeLevel);
      return {
        id: 'operator',
        schema: {
          type: 'string',
          enum: allowedRelations
        },
        builtin: false,
        mandatory_for_planners: true,
        type: 'select',
        label: '',
        category: '',
        name: 'operator',
        attributeTranslations: getCriteriaRelationAttributeTranslations(this.sharedSvc, this.translateService.currentLang),
        editable: allowedRelations.length > 0
      };
    }
    addCriteria() {
      this.criteriaTree.criteria.push(getNewCriteria(this.filterData?.availableFields, this.sharedSvc));
    }
    addCriteriaRelation() {
      this.criteriaTree.criteria.push(getNewCriteriaTree(this.currentTreeLevel + 1, this.filterData, this.sharedSvc));
    }
    onDeleteNode(index) {
      this.criteriaTree.criteria.splice(index, 1);
    }
    onCriteriaRelationChanges(changes) {
      this.criteriaTree.operator = changes.value;
    }
    static {
      this.ɵfac = function AzavistaFilterCriteriaTreeNodesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFilterCriteriaTreeNodesComponent)(i0.ɵɵdirectiveInject(i1.AzavistaSharedService), i0.ɵɵdirectiveInject(i2.TranslateService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaFilterCriteriaTreeNodesComponent,
        selectors: [["azavista-filter-criteria-tree-nodes"]],
        inputs: {
          filterData: "filterData",
          criteriaTree: "criteriaTree",
          autoGenerateFirstCriteria: "autoGenerateFirstCriteria",
          currentTreeLevel: "currentTreeLevel",
          criteriaRelationField: "criteriaRelationField"
        },
        standalone: false,
        decls: 4,
        vars: 2,
        consts: [["operatorEl", ""], ["deleteButtonEl", ""], [4, "ngFor", "ngForOf"], ["class", "filter-tree__tree-nodes__add-area", 3, "filter-tree__tree-nodes__indent", 4, "ngIf"], [4, "ngIf"], ["mat-icon-button", "", 3, "click", 4, "ngIf"], ["mat-icon-button", "", 3, "click"], [1, "filter-tree__horizonal-stack"], ["class", "filter-tree__tree-nodes__operator-wrapper", 3, "visibility", 4, "ngIf"], [3, "allFields", "criteriaItem", "readonly", "deleteNode", 4, "ngIf"], [1, "filter-tree__tree-nodes__breakspace", 2, "flex", "1"], [1, "filter-tree__tree-nodes__operator-wrapper"], [3, "ngTemplateOutlet"], [3, "deleteNode", "allFields", "criteriaItem", "readonly"], [1, "filter-tree__tree-nodes"], [1, "filter-tree__horizonal-stack", "filter-tree__tree-nodes__parent-operator"], ["color", "warn", "mat-button", "", 3, "click", 4, "ngIf"], [3, "criteriaTree", "currentTreeLevel", "filterData"], ["color", "warn", "mat-button", "", 3, "click"], [1, "filter-tree__tree-nodes__add-area"], [3, "click", 4, "ngIf"], [3, "click"], [1, "filter-tree__tree-nodes__operator", 3, "valueChanged", "field", "value", "readonlyMode", "editMode"]],
        template: function AzavistaFilterCriteriaTreeNodesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, AzavistaFilterCriteriaTreeNodesComponent_ng_container_0_Template, 5, 2, "ng-container", 2)(1, AzavistaFilterCriteriaTreeNodesComponent_div_1_Template, 3, 4, "div", 3)(2, AzavistaFilterCriteriaTreeNodesComponent_ng_template_2_Template, 1, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngForOf", ctx.criteriaTree == null ? null : ctx.criteriaTree.criteria);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.filterData.readonly);
          }
        },
        dependencies: [i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, i4.AzavistaFlatButtonComponent, i5.AzavistaInputFieldComponent, i6.MatIcon, i7.MatButton, i7.MatIconButton, AzavistaFilterCriteriaTreeNodesComponent, AzavistaFilterCriteriaTreeNodeComponent, i3.UpperCasePipe, i2.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return AzavistaFilterCriteriaTreeNodesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Dialog Component for managing filter tree.
 *
 * Use `FilterCriteriaTreeService.open()` to open the dialog.
 */
let AzavistaFilterCriteriaTreeComponent = /*#__PURE__*/(() => {
  class AzavistaFilterCriteriaTreeComponent {
    constructor(sharedSvc, dialogRef, data) {
      this.sharedSvc = sharedSvc;
      this.dialogRef = dialogRef;
      this.data = data;
      this.nameField = this.getNameField();
      this.isValidFilterTree = isValidFilterTree;
      this.autoGenerateFirstCriteria = this.data.filter?.criteriaTree == null;
      // remove invalid criteria and then re-initiate criteriaTree if its null
      data.filter.criteriaTree = getValidatedCriteriaTree(data.filter.criteriaTree, data.availableFields, sharedSvc);
      if (data.filter.criteriaTree == null) {
        data.filter.criteriaTree = {
          criteria: [],
          operator: data.allowedCriteriaRelationPerTreeLevel[0][0] ?? CriteriaRelationOperator.and
        };
      }
    }
    getNameField() {
      return {
        id: 'name',
        builtin: true,
        schema: {
          type: 'string'
        },
        type: 'text',
        label: this.sharedSvc.translate('NAME'),
        category: '',
        name: 'name',
        placeholder: this.sharedSvc.translate('FILTER_NAME'),
        editable: true,
        mandatory_for_planners: true
      };
    }
    onNameChanges(changes) {
      this.data.filter.name = changes.value;
    }
    submit(value) {
      this.dialogRef.close(value ? {
        type: 'submit',
        data: this.getFilterTreeFromData(value),
        dialogState: this.data
      } : {
        type: 'cancel',
        dialogState: this.data
      });
    }
    onDelete() {
      this.dialogRef.close({
        type: 'delete',
        dialogState: this.data
      });
    }
    clearAll() {
      clearCriteriaTree(this.data.filter.criteriaTree);
    }
    getFilterTreeFromData(value) {
      return value;
    }
    static {
      this.ɵfac = function AzavistaFilterCriteriaTreeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFilterCriteriaTreeComponent)(i0.ɵɵdirectiveInject(i1.AzavistaSharedService), i0.ɵɵdirectiveInject(i2$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaFilterCriteriaTreeComponent,
        selectors: [["azavista-filter-criteria-tree"]],
        standalone: false,
        decls: 13,
        vars: 13,
        consts: [["mat-dialog-title", "", 1, "aza-cmp-dialog-title"], [4, "ngIf"], ["layoutDensity", "slim", 3, "valueChanged", "invalidValueSet", "field", "value", "editMode", "readonlyMode"], ["mat-dialog-action", "", 1, "filter-tree__dialog-actions", "filter-tree__horizonal-stack", "aza-cmp-dialog-actions", "no-padding"], [3, "filterData", "criteriaTree", "autoGenerateFirstCriteria"], ["mat-dialog-action", "", 1, "filter-tree__dialog-actions", "filter-tree__horizonal-stack", "aza-cmp-dialog-actions"], [1, "filter-tree__horizonal-stack"], [3, "click", 4, "ngIf"], ["color", "primary", 3, "click", 4, "ngIf"], ["color", "warn", 3, "click", 4, "ngIf"], ["color", "primary", 3, "disabled", "click", 4, "ngIf"], [3, "click"], ["color", "primary", 3, "click"], ["color", "warn", 3, "click"], ["color", "primary", 3, "click", "disabled"]],
        template: function AzavistaFilterCriteriaTreeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h1", 0);
            i0.ɵɵtemplate(1, AzavistaFilterCriteriaTreeComponent_ng_container_1_Template, 2, 1, "ng-container", 1)(2, AzavistaFilterCriteriaTreeComponent_ng_container_2_Template, 3, 3, "ng-container", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "azavista-input-field", 2);
            i0.ɵɵlistener("valueChanged", function AzavistaFilterCriteriaTreeComponent_Template_azavista_input_field_valueChanged_3_listener($event) {
              return ctx.onNameChanges($event);
            })("invalidValueSet", function AzavistaFilterCriteriaTreeComponent_Template_azavista_input_field_invalidValueSet_3_listener($event) {
              return ctx.onNameChanges($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(4, "div", 3)(5, "azavista-filter-criteria-tree-nodes", 4);
            i0.ɵɵelementStart(6, "div", 5)(7, "div", 6);
            i0.ɵɵtemplate(8, AzavistaFilterCriteriaTreeComponent_azavista_button_8_Template, 4, 5, "azavista-button", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 6);
            i0.ɵɵtemplate(10, AzavistaFilterCriteriaTreeComponent_azavista_flat_button_10_Template, 4, 5, "azavista-flat-button", 8)(11, AzavistaFilterCriteriaTreeComponent_azavista_button_11_Template, 4, 5, "azavista-button", 9)(12, AzavistaFilterCriteriaTreeComponent_azavista_button_12_Template, 4, 6, "azavista-button", 10);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.data.dialogTitle);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.data.dialogTitle);
            i0.ɵɵadvance();
            i0.ɵɵproperty("field", ctx.nameField)("value", ctx.data.filter == null ? null : ctx.data.filter.name)("editMode", true)("readonlyMode", ctx.data.readonly);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("filterData", ctx.data)("criteriaTree", ctx.data == null ? null : ctx.data.filter == null ? null : ctx.data.filter.criteriaTree)("autoGenerateFirstCriteria", ctx.autoGenerateFirstCriteria);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.data.readonly);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.data.readonly);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.data.canDelete);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.data.readonly);
          }
        },
        dependencies: [i3.NgIf, i2$1.MatDialogTitle, i4.AzavistaButtonComponent, i4.AzavistaFlatButtonComponent, i5.AzavistaInputFieldComponent, AzavistaFilterCriteriaTreeNodesComponent, i3.UpperCasePipe, i2.TranslatePipe],
        styles: ["azavista-filter-criteria-tree{display:flex;flex-direction:column;height:100%}azavista-filter-criteria-tree *{font-size:12px}azavista-filter-criteria-tree .mat-mdc-dialog-title.mdc-dialog__title{border-bottom:none}azavista-filter-criteria-tree .filter-tree__horizonal-stack{display:flex;align-items:center;flex-wrap:wrap;gap:0px 1em;padding:2px 0}azavista-filter-criteria-tree .filter-tree__tree-nodes{background-color:#f0f0f0b3;margin-bottom:1.5em;border-radius:.5em;padding:1em 0}azavista-filter-criteria-tree .filter-tree__tree-nodes__indent{padding-left:4em}azavista-filter-criteria-tree .filter-tree__tree-nodes__parent-operator{justify-content:space-between;padding:0 20px}azavista-filter-criteria-tree .filter-tree__tree-nodes__operator-wrapper{width:100%}azavista-filter-criteria-tree .filter-tree__tree-nodes__breakspace{display:none}azavista-filter-criteria-tree .filter-tree__tree-nodes__operator{max-width:5em;max-height:2em;display:flex;align-items:center}azavista-filter-criteria-tree .filter-tree__tree-nodes__left-border{border-left:3px solid rgba(0,0,0,.1);display:block;margin-top:1.5em}azavista-filter-criteria-tree .filter-tree__tree-nodes__add-area{display:flex;flex-direction:column;width:fit-content}azavista-filter-criteria-tree .filter-tree__dialog-actions{margin-top:3em;justify-content:space-between}azavista-filter-criteria-tree .filter-tree__dialog-actions.no-padding{margin-top:1em;padding:0!important}azavista-filter-criteria-tree>azavista-filter-criteria-tree-nodes{flex:1;max-height:calc(90vh - 20em);display:block;padding:0 0 1em;overflow-y:auto}azavista-filter-criteria-tree azavista-filter-criteria-tree-node{flex:1}azavista-filter-criteria-tree azavista-filter-criteria-tree-node azavista-input-field{flex:1}azavista-filter-criteria-tree azavista-filter-criteria-tree-node .filter-tree__node--has-category .azavista-input-field-filter-value{flex:2}azavista-filter-criteria-tree .aza-hour-field,azavista-filter-criteria-tree .aza-minute-field,azavista-filter-criteria-tree .aza-meridiem-field{max-width:4em}azavista-filter-criteria-tree .aza-input-field-container-type-datetime{flex-wrap:wrap}azavista-filter-criteria-tree .hidden{display:none}\n"],
        encapsulation: 2
      });
    }
  }
  return AzavistaFilterCriteriaTreeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Filter the filter tree by removing criteria that has no field reference on the `availableFields`
 */
const getValidatedCriteriaTree = (criteriaTree, availableFields, sharedSvc) => {
  const validatedCriteria = criteriaTree?.criteria?.map(item => {
    const {
      operator
    } = item;
    if (operator === CriteriaRelationOperator.and || operator === CriteriaRelationOperator.or) {
      return getValidatedCriteriaTree(item, availableFields, sharedSvc);
    } else {
      return getValidatedFilterNode(item, availableFields, sharedSvc);
    }
  }).filter(item => !!item) ?? [];
  return validatedCriteria?.length > 0 ? {
    ...criteriaTree,
    criteria: validatedCriteria
  } : null;
};
const getValidatedFilterNode = (filterNode, availableFields, sharedSvc) => {
  const field = availableFields.find(({
    id
  }) => id === filterNode.field.id);
  if (!field) {
    return null;
  }
  const fieldType = sharedSvc.getFieldTypeFromField(field);
  if (fieldType === 'select') {
    const enumItems = sharedSvc.getEnumItems(field.schema);
    filterNode.value = (filterNode.value ?? []).filter(item => enumItems.includes(item));
  }
  if (fieldType === 'multi-select') {
    const arrayItems = sharedSvc.getArrayItems(field.schema);
    filterNode.value = (filterNode.value ?? []).filter(item => arrayItems.includes(item));
  }
  return filterNode;
};
let AzavistaFilterCriteriaTreeService = /*#__PURE__*/(() => {
  class AzavistaFilterCriteriaTreeService {
    constructor(dialog, sharedSvc) {
      this.dialog = dialog;
      this.sharedSvc = sharedSvc;
    }
    async open(data, dialogOptions) {
      const clonedDataFilter = this.sharedSvc.clone(data.filter);
      const result = await firstValueFrom(this.dialog.open(AzavistaFilterCriteriaTreeComponent, {
        ...dialogOptions,
        disableClose: true,
        maxHeight: '90vh',
        // the data should be cloned to new object,
        // otherwise it will get overwritten
        data: {
          ...data,
          filter: clonedDataFilter
        }
      }).afterClosed());
      this.lastDialogData = result?.dialogState;
      return omit(result, ['dialogState']);
    }
    async reopenLastDialog(dialogOptions) {
      return this.open(this.lastDialogData, dialogOptions);
    }
    static {
      this.ɵfac = function AzavistaFilterCriteriaTreeService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFilterCriteriaTreeService)(i0.ɵɵinject(i2$1.MatDialog), i0.ɵɵinject(i1.AzavistaSharedService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AzavistaFilterCriteriaTreeService,
        factory: AzavistaFilterCriteriaTreeService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AzavistaFilterCriteriaTreeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaFilterCriteriaTreeModule = /*#__PURE__*/(() => {
  class AzavistaFilterCriteriaTreeModule {
    static {
      this.ɵfac = function AzavistaFilterCriteriaTreeModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFilterCriteriaTreeModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AzavistaFilterCriteriaTreeModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [AzavistaFilterCriteriaTreeService],
        imports: [CommonModule, MatDialogModule, TranslateModule, AzavistaButtonModule, AzavistaInputFieldModule]
      });
    }
  }
  return AzavistaFilterCriteriaTreeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AzavistaFilterCriteriaTreeComponent, AzavistaFilterCriteriaTreeModule, AzavistaFilterCriteriaTreeNodeComponent, AzavistaFilterCriteriaTreeNodesComponent, AzavistaFilterCriteriaTreeService, CRITERIA_RELATIONS_ARRAY, CRITERIA_RELATIONS_TRANSLATION, IsValidCriteriaTree, clearCriteriaTree, filterTreeToFlatSearchParams, filterTreeToFlatSearchParamsElement, flatSearchElementToFilterTree, flatSearchParamsToFilterTree, formatFilterTree, getAllowedRelations, getCriteriaDefaultValue, getCriteriaDefaultValueByFieldType, getCriteriaRelationAttributeTranslations, getNewCriteria, getNewCriteriaTree, inputFieldTypeDefaultValue, isValidFilterTree };
